
import { Typography, CircularProgress, Button, useTheme, Tooltip } from '@mui/material'
import React from 'react'

interface GeneralCreateButtonProps {
  text: string
  customColor?: string
  onClick: () => void
  isCreating: boolean
  disabled: boolean
  icon?: React.ReactNode
  customWidth?: string
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' | 'left-start' | 'left-end' | 'right-start' | 'right-end'
}

const GeneralCreateButton: React.FC<GeneralCreateButtonProps> = ({
  text = 'Create',
  customColor,
  icon,
  onClick,
  isCreating,
  disabled,
  customWidth = '100%',
  placement = 'right',
}) => {
  const theme = useTheme()
  return (
    <Tooltip placement={placement} title={<Typography>{text ? text : `Log ${text}`}</Typography>}>
      <div>
        <Button
          sx={{
            height: '100%',
            width: customWidth,
            // backgroundColor: customColor ?? 'rgb(29, 106, 82)',
            justifyContent: 'left',
            border: `0.5px solid`,
            bgcolor: 'background.defaultdim',
            borderColor: customColor ?? 'text.primary',
          }}
          startIcon={icon ?? null}
          disabled={isCreating || disabled}
          onClick={onClick}
          name="general-create-button"
          variant="contained"
        >
          {isCreating ? (
            <Typography>
              Creating...{' '}
              <CircularProgress
                size={15}
                sx={{
                  color: theme.palette.text.secondary,
                }}
              />
            </Typography>
          ) : (
            <Typography>{text}</Typography>
          )}
        </Button>
      </div>
    </Tooltip>
  )
}

export default GeneralCreateButton
